export default __webpack_public_path__ + "static/media/1247.40909572.png";